import { render, staticRenderFns } from "./electros.vue?vue&type=template&id=0723920c&"
import script from "./electros.vue?vue&type=script&lang=js&"
export * from "./electros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports